import "core-js/modules/es6.array.is-array";
export default (function (value) {
  return Array.isArray(value);
});